/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { getter, process } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { getSelectedState, Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  Badge,
  Input,
  Switch,
  Combobox,
  DatePicker,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Textarea,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@repo/ui";
import { formatDate } from "date-fns";
import { CircleX, SlidersHorizontal } from "lucide-react";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { saveFilters } from "utils/actions/user";
import {
  useGetB2BDeliveryPartialPackages,
  useReRouteB2bPartialDeliveryPackages,
  useVerifyDeliveryPartialSealNo,
} from "utils/apis/home.api";
import {
  useGetCITList,
  useGetCustomers,
  useGetCustomerServicePointsBySource,
  useGetRouteByCashCenter,
} from "utils/apis/lookups.api";
import {
  checkAllObjectsExist,
  checkArrayHasSameId,
  getLink,
  showToast,
} from "utils/helper";
import { UserContext } from "utils/reducers/user";
import Swal from "sweetalert2";

const pageSize = 25;

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export default function PartialPackages() {
  const user = useContext(UserContext);
  let excelExport: ExcelExport | null;

  const [filters, setFilters] = useState<any>(
    user?.filters?.["package-verification-services"] || {},
  );
  const [selectedState, setSelectedState] = useState<any>({});
  const [dataState, setDataState] = useState<any>(initialDataState);
  const [selectedRequests, setSelectedRequests] = useState<any[]>([]);
  const DATA_ITEM_KEY = "selectedId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const [openReRouteDialog, setOpenReRouteDialog] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [onwardLocation, setOnwardLocation] = useState("");
  const [ddlSourceLocation, setDdlSourceLocation] = useState("");
  const [serviceDateTime, setServiceDateTime] = useState(new Date());
  const [routeNo, setRouteNo] = useState("");
  const [pendingCategory, setPendingCategory] = useState("Reroute");
  const [reasonDescription, setReasonDescription] = useState("");
  const currentDate = new Date();
  const [sealNo, setSealNo] = useState("");
  const [packagesConsignments, setPackagesConsignments] = useState<any>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const { data: sourceLocationsData } = useGetCITList();
  const { data: onwardLocationsData } =
    useGetCustomerServicePointsBySource(ddlSourceLocation);
  const { data: customers } = useGetCustomers();

  const { data: deliveryPackagesVerificationData } =
    useGetB2BDeliveryPartialPackages({
      pageNumber: currentPage || 1,
      pageRowCount: pageSize,
      searchCriteria:
        filters?.searchCriteria?.id.length >= 3
          ? filters?.searchCriteria?.id
          : "",
      operationDate: formatDate(
        filters?.operationDate?.id || new Date(),
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      cashCenterId: user.CashCenterId,
      customerId: filters?.customer?.id || "",
      sourceSPId: filters?.sourceLocation?.id || "",
      onwardSPId: filters?.onwardLocation?.id || "",
    });

  const { data: inRouteTeams } = useGetRouteByCashCenter(user.CashCenterId);
  const { mutate: verifyDeliverySealNo } = useVerifyDeliveryPartialSealNo();
  const {
    mutate: reRoutePackages,
    isPending: reRoutePending,
    isSuccess: reRouteSuccess,
  } = useReRouteB2bPartialDeliveryPackages();

  const onPageChange = (e: any) => {
    const _currentPage = e.page.skip / e.page.take + 1;
    setCurrentPage(_currentPage);
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: { name: formatDate(value, "PPP"), id: value },
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "package-verification-services": {
          ...filters,
          operationDate: { name: formatDate(value, "PPP"), id: value },
        },
      });
    }
    setCurrentPage(1);
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: { name: e.target.value, id: e.target.value },
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "package-verification-services": {
        ...filters,
        searchCriteria: { name: e.target.value, id: e.target.value },
      },
    });
  };

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "package-verification-services": updatedFilter,
    });
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-shadow
    const { sourceLocation, onwardLocation, ...remainingFilters } = filters;
    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val),
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "package-verification-services": {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val),
      },
    });
  };

  const handleBillingCustomer = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("customer", val);
  };

  const handleSourceLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("sourceLocation", val);
  };

  const handleDestinationLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("onwardLocation", val);
  };

  const verifyBag = (e: any) => {
    const seal = e.target.value;

    if (!seal || !packagesConsignments?.length) {
      return;
    }

    const bagScanned = packagesConsignments?.find(
      (bag: any) => bag.sealNo === seal && bag.scanned,
    );

    if (bagScanned) {
      showToast("error", "Seal already scanned.");
      return;
    }

    const bagFound = packagesConsignments?.findIndex(
      (srb: any) => srb.sealNo === seal,
    );
    if (bagFound !== -1) {
      const updatedArray = packagesConsignments?.slice();
      verifyDeliverySealNo({
        deliveryDate: formatDate(
          filters?.operationDate?.id || currentDate,
          "yyyy-MM-dd",
        ),
        sealNo: seal,
        requestId: packagesConsignments[bagFound]?.requestId,
        serviceType: packagesConsignments[bagFound]?.serviceType,
      });
      updatedArray[bagFound] = {
        ...packagesConsignments[bagFound],
        scanned: true,
      };
      setPackagesConsignments(updatedArray);
    }

    setSealNo("");
  };

  const handleOnChangeReRouteDialog = (val: boolean) => {
    setOpenReRouteDialog(val);
    setSelectedRequests([]);
    setDdlSourceLocation("");
    setSelectedState({});
  };

  function ShowOrderIDCell({ dataItem }: any) {
    const { requestId, jobNo } = dataItem;

    return (
      <td>
        {dataItem.serviceType ? (
          <Link
            to={getLink(dataItem?.serviceType)}
            state={{ requestId, jobNo, isReRoute: true }}
          >
            {dataItem.orderId}
          </Link>
        ) : (
          dataItem.orderId
        )}
      </td>
    );
  }

  function ScannedCell({ dataItem }: any) {
    const handleCoinScannedChange = (val: boolean) => {
      const updatedArray = packagesConsignments?.slice();
      const itemIndex = packagesConsignments?.findIndex(
        (srb: any) => srb.selectedId === dataItem.selectedId,
      );
      if (itemIndex !== -1) {
        updatedArray[itemIndex] = {
          ...packagesConsignments[itemIndex],
          scanned: val,
        };
        setPackagesConsignments(updatedArray);
      }
    };
    return (
      <td className="text-center mt-3">
        <Switch
          checked={dataItem.scanned}
          disabled={dataItem.sealNo}
          onCheckedChange={handleCoinScannedChange}
        />
      </td>
    );
  }

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req) => ({
      itemKey: req.itemKey,
    }));

    const consignmentsArray = packagesConsignments?.filter((item: any) =>
      requestIds.some((req: any) => req.itemKey === item.selectedId),
    );

    setDdlSourceLocation(consignmentsArray?.[0]?.sourceSPId);
    setSelectedRequests(consignmentsArray);
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedReq = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedReq.map((req) => ({
      itemKey: req.itemKey,
    }));

    const consignmentsArray = packagesConsignments?.filter((item: any) =>
      requestIds.some((req: any) => req.itemKey === item.selectedId),
    );

    setDdlSourceLocation(consignmentsArray?.[0]?.sourceSPId);
    setSelectedRequests(consignmentsArray);
  };

  const handleReRoutePackage = () => {
    if (!selectedRequests?.length) {
      showToast("error", "Please select at least one package to re-route.");
      return;
    }

    const isErrors = checkAllObjectsExist(
      packagesConsignments,
      selectedRequests,
    );
    if (isErrors) {
      Swal.fire({
        icon: "warning",
        html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${isErrors?.join(",").replaceAll(",", "</li><li>")}</li></ul>`,
      });
      setSelectedRequests([]);
      setDdlSourceLocation("");
      setSelectedState({});
      return;
    }

    if (!openReRouteDialog) {
      setOpenReRouteDialog(true);
      if (checkArrayHasSameId(selectedRequests)) {
        const location = onwardLocationsData?.find(
          (i: any) => i.barcode === selectedRequests?.[0]?.onwardBarcode,
        );
        setOnwardLocation(location?.servicePointId);
      }
    } else {
      reRoutePackages({
        onwardSPId: onwardLocation,
        routeNo,
        serviceDateTime: formatDate(
          serviceDateTime || new Date(),
          "yyyy-MM-dd'T'00:00:00.000'Z'",
        ),
        pendingCategory,
        reasonDescription,
        requests: selectedRequests?.map((req: any) => ({
          requestId: req?.requestId,
          jobNo: req?.jobNo,
          serviceType: req?.serviceType,
          jobType: req?.jobType,
          sealNo: req?.sealNo,
          scanned: req?.scanned,
        })),
        remarks,
      });
    }
  };

  const handleExportExcel = () => {
    if (packagesConsignments?.length) {
      excelExport?.save(packagesConsignments);
    }
  };

  useEffect(() => {
    if (deliveryPackagesVerificationData?.data?.length) {
      const formattedData = deliveryPackagesVerificationData?.data?.map(
        (item: any) => ({
          ...item,
          selectedId: crypto.randomUUID(),
        }),
      );
      setPackagesConsignments(formattedData);
      setTotalRecords(deliveryPackagesVerificationData?.totalRecords || 0);
    } else {
      setPackagesConsignments([]);
      setTotalRecords(0);
    }
  }, [deliveryPackagesVerificationData]);

  useEffect(() => {
    if (reRouteSuccess) {
      handleOnChangeReRouteDialog(false);
    }
  }, [reRouteSuccess]);
  return (
    <>
      <div className="flex my-3 gap-3">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="secondary" className="p-2" title="Apply Filters">
              <SlidersHorizontal className="" />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-[600px]">
            <h6 className="font-semibold text-lg">Apply Filters</h6>
            <div className="grid grid-cols-2 gap-4 mt-3">
              <Combobox
                placeholder="Select Customer"
                value={JSON.stringify(filters?.customer) || ""}
                data={customers?.map((item) => ({
                  value: JSON.stringify({
                    name: item.name,
                    id: item.customerId,
                  }),
                  label: item.name,
                }))}
                setValue={handleBillingCustomer}
              />

              <Combobox
                placeholder="Select Source Location"
                value={JSON.stringify(filters?.sourceLocation) || ""}
                data={sourceLocationsData?.map((item: any) => ({
                  value: JSON.stringify({
                    name: `${item.barcode}-${item.locationId}`,
                    id: item.servicePointId,
                  }),
                  label: `${item.barcode}-${item.locationId}`,
                }))}
                setValue={handleSourceLocation}
              />

              <Combobox
                placeholder="Select Destination Location"
                value={JSON.stringify(filters?.onwardLocation) || ""}
                data={onwardLocationsData?.map((item: any) => ({
                  value: JSON.stringify({
                    name: `${item.barcode}-${item.locationId}`,
                    id: item.servicePointId,
                  }),
                  label: `${item.barcode}-${item.locationId}`,
                }))}
                setValue={handleDestinationLocation}
              />
            </div>
          </PopoverContent>
        </Popover>

        <div className="w-[15%]">
          <DatePicker
            placeholder="Select Operation Date"
            selectedDate={filters?.operationDate?.id || new Date()}
            onSelectDate={onOperationDateChanged}
          />
        </div>

        <Input
          className="w-full max-w-[420px] ml-auto"
          value={filters.searchCriteria?.id}
          onChange={onFilterSearch}
          title="Search: Order Id, Job No., Seal No."
          placeholder="Search: Order Id, Job No., Seal No."
        />
        <Button
          variant="secondary"
          onClick={handleExportExcel}
          disabled={!packagesConsignments?.length}
        >
          Export Excel
        </Button>
      </div>
      <div className="flex gap-2 flex-wrap my-3 items-center">
        {Object.entries(filters).map(([key, val]: any, i) =>
          val.id ? (
            <Badge
              variant="secondary"
              className="gap-3 pr-1 cursor-pointer"
              key={i}
            >
              {val?.name}{" "}
              <CircleX
                onClick={() => {
                  handleClearFilter(key);
                }}
              />
            </Badge>
          ) : null,
        )}
      </div>
      <div className="border-b my-3 bg-accent" />

      <div className="flex gap-3">
        <Input
          className="max-w-[686px] w-full"
          placeholder="Scan bag"
          value={sealNo}
          onChange={(e) => {
            setSealNo(e.target.value);
          }}
          onBlur={verifyBag}
        />
        <div className="border py-1 rounded-md flex items-center justify-center px-4">
          {packagesConsignments?.filter((i: any) => i.scanned)?.length} /{" "}
          {deliveryPackagesVerificationData?.data?.length || 0}
        </div>

        <Button
          className="ml-auto"
          variant="secondary"
          size="sm"
          onClick={handleReRoutePackage}
          disabled={!selectedRequests?.length}
          isLoading={reRoutePending}
        >
          Re-Route Packages
        </Button>
      </div>
      <div className="border-b my-3 bg-accent" />
      <Grid
        pageable
        onPageChange={onPageChange}
        pageSize={pageSize}
        total={totalRecords}
        skip={(currentPage - 1) * pageSize}
        take={pageSize}
        sortable
        filterable
        size="small"
        dataItemKey={DATA_ITEM_KEY}
        selectedField={SELECTED_FIELD}
        selectable={{
          enabled: true,
          drag: true,
          cell: false,
          mode: "multiple",
        }}
        data={process(
          packagesConsignments?.map((req: any) => ({
            ...req,
            [SELECTED_FIELD]: selectedState[idGetter(req)],
          })) || [],
          { ...dataState, skip: 0 },
        )}
        {...dataState}
        onDataStateChange={(e) => {
          setDataState(e.dataState);
        }}
        onSelectionChange={onSelectionChange}
        onHeaderSelectionChange={onHeaderSelectionChange}
      >
        <GridColumn
          field={SELECTED_FIELD}
          filterable={false}
          width="40px"
          headerSelectionValue={
            packagesConsignments?.findIndex(
              (item: any) => !selectedState[idGetter(item)],
            ) === -1
          }
        />
        <GridColumn
          field="orderId"
          width={140}
          title="Order Id"
          cell={ShowOrderIDCell}
        />
        <GridColumn
          field="scanned"
          title="Scanned"
          width={90}
          cell={ScannedCell}
        />
        {/* <GridColumn
          field="rerouted"
          title="Rerouted"
          width={90}
          cell={ReRoutedCell}
        /> */}
        <GridColumn field="jobNo" title="Job No" width={100} />
        <GridColumn field="customer" title="Customer" width={180} />
        <GridColumn
          field="sourceBarcode"
          title="Source"
          width={240}
          cell={({ dataItem }) => (
            <td>{`${dataItem?.sourceBarcode}-${dataItem?.sourceLocationId}`}</td>
          )}
        />
        <GridColumn
          field="onwardBarcode"
          title="Onward By Field Team"
          width={240}
          cell={({ dataItem }) => (
            <td>{`${dataItem?.onwardBarcode}-${dataItem?.onwardLocationId}`}</td>
          )}
        />

        <GridColumn field="containerType" width={140} title="Bag Type" />
        <GridColumn field="amount" width={140} title="Amount" />
        <GridColumn field="sealNo" width={140} title="Seal No" />
        <GridColumn
          field="collectedByRoute"
          width={160}
          title="Collected By Route"
        />
        <GridColumn field="ctlName" width={160} title="CTL Name" />
        <GridColumn
          field="plannedToRoute"
          width={160}
          title="Planed To Route"
        />
        <GridColumn field="status" width={140} title="Status" />

        <GridColumn field="remarks" width={210} title="Remarks" />
      </Grid>
      <ExcelExport
        ref={(exporter) => {
          excelExport = exporter;
        }}
        fileName={`Re-route_Partial_Deliveries_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "orderId", title: "Order Id" },
          { field: "jobNo", title: "Job No" },
          { field: "customer", title: "Customer" },
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "sourceLocationName", title: "Source Location" },
          {
            field: "onwardBarCodeByFieldTeam",
            title: "Onward Barcode By Field Team",
          },
          {
            field: "onwardLocationNameByFieldTeam",
            title: "Onward Location Name By Field Team",
          },
          { field: "onwardBarcode", title: "Actual Onward Barcode" },
          { field: "onwardLocationName", title: "Actual Onward Location Name" },
          { field: "containerType", title: "Bag Type" },
          { field: "amount", title: "Amount" },
          { field: "sealNo", title: "Seal No" },
          { field: "collectedByRoute", title: "Collected By Route" },
          { field: "ctlName", title: "CTL Name" },
          { field: "plannedToRoute", title: "Planed To Route" },
          { field: "status", title: "Status" },
          { field: "scanned", title: "Scanned" },
          { field: "rerouted", title: "Rerouted" },
          { field: "remarks", title: "Remarks" },
        ]}
      />
      <Dialog
        open={openReRouteDialog}
        onOpenChange={handleOnChangeReRouteDialog}
      >
        <DialogContent className="max-w-[620px]" disableOutsideClick>
          <DialogHeader>
            <DialogTitle>Re-Route Packages</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <div className="min-w-[200px] w-full">
              <Select
                onValueChange={setPendingCategory}
                value={pendingCategory}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select Status" />
                </SelectTrigger>
                <SelectContent>
                  {[
                    {
                      label: "Close - Returned to Cash Center",
                      value: "Close",
                    },
                    {
                      label: "Re-Route - Re‑dispatched to customer",
                      value: "Reroute",
                    },
                  ].map((item) => (
                    <SelectItem
                      key={item.label}
                      onClick={() => {
                        setReasonDescription(item.label);
                      }}
                      value={item.value}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="flex flex-wrap mt-3 gap-3 px-1">
              {pendingCategory === "Reroute" ? (
                <>
                  {checkArrayHasSameId(selectedRequests) ? (
                    <div className="flex-[0.5] min-w-[200px]">
                      <Combobox
                        data={onwardLocationsData?.map((sp: any) => ({
                          label: `${sp.barcode}-${sp.locationId}`,
                          value: sp.servicePointId,
                        }))}
                        value={onwardLocation}
                        placeholder="Select Location"
                        setValue={setOnwardLocation}
                      />
                    </div>
                  ) : null}
                  <div className="flex-[0.5] min-w-[200px]">
                    <DatePicker
                      placeholder="Select Operation Date"
                      selectedDate={serviceDateTime}
                      onSelectDate={setServiceDateTime}
                    />
                  </div>
                  <div className="flex-[0.5] min-w-[200px]">
                    <Combobox
                      data={inRouteTeams?.map((m: any) => ({
                        value: m.routeNo,
                        label: `${m.routeNo} (${m.description})`,
                      }))}
                      value={routeNo}
                      placeholder="Select Route"
                      setValue={setRouteNo}
                    />
                  </div>
                </>
              ) : null}

              <Textarea
                className="w-full resize-none"
                value={remarks}
                placeholder="Enter remarks (optional)"
                onChange={(e) => {
                  setRemarks(e.target.value);
                }}
              />
            </div>

            <div className="flex justify-end gap-2 mt-2">
              <Button
                variant="outline"
                onClick={() => {
                  setOpenReRouteDialog(false);
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={pendingCategory === "Reroute" ? !routeNo : false}
                variant="secondary"
                onClick={handleReRoutePackage}
              >
                Confirm
              </Button>
            </div>
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </>
  );
}
